import React, { useEffect, useRef, useState } from 'react'
import { Divider, message, Spin } from 'antd'
import {
  SLowcodeList,
  STableActions,
  SActionBtn,
} from 'shj-components'
import config from './config';
import { verifyApplyFindResponseListByPage, cancelVerify, httpDictServTenant, findQuotationTypes, getEnum } from '@/services/fmsServices'
import { useParams } from 'react-router-dom'
export default function PaymentServiceManage(props) {
  const [loading, setLoading] = useState(false);
  let listRef = useRef<any>();
  const { id } = props
  useEffect(() => {
    reloadFn()
  }, [id])
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        const { verifiedDate, sourceBillTypeList, sourceTypeList, contractTypeList } = query
        // 处理日期范围
        if (verifiedDate?.length) {
            const [start, end] = verifiedDate;
            query.verifiedDateStartStr = start.format('YYYY-MM-DD 00:00:00');
            query.verifiedDateEndStr = end.format('YYYY-MM-DD 23:59:59');
            delete query.verifiedDate;
        }

        // 处理列表类型参数
        const listParams = [
            { key: 'sourceBillTypeList', value: sourceBillTypeList },
            { key: 'sourceTypeList', value: sourceTypeList }, 
            { key: 'contractTypeList', value: contractTypeList }
        ];
        
        listParams.forEach(({ key, value }) => {
            if (value) query[key] = [value];
        });
        verifyApplyFindResponseListByPage(current, pageSize, { orderAccountId: id, ...query}).then((res) => {
          resolve(res)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  const cancel = (record: any) => {
    setLoading(true)
    cancelVerify({
      id: record.id
    }).then((res) => {
      message.success(res.message || '取消成功')
      setLoading(false)
      reloadFn()
    }).catch(err => {
      setLoading(false)
    })
  }
  const getStatusOptions = () => {
    return new Promise(async resolve => {
      let receiptTypeList: any = await httpDictServTenant({ parentKey: 'receiptType',enabled: 1 })
      let transactionFeeTypeList: any = await httpDictServTenant({
        parentKey: 'transactionFeeType',
        enabled: 1,
      })
      let contractTypeList = await findQuotationTypes()
      const sourceBillTypeList: any = await getEnum('com.shj.saas.plus.fms.enums.VerifySourceBillTypeEnum')
      resolve({
        receiptTypeList: [...receiptTypeList, ...transactionFeeTypeList],
        contractTypeList,
        sourceBillTypeList,
      },)
    })
  }
  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: {},
    customRender: {
      renderOperate(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn auth="VerificationDetailsCancel" onClick={() => cancel(record)}>
              取消核销
            </SActionBtn>
          </STableActions>
        )
      },
      verifiedAmountRender(text: any, record: any) {
        return (
          <div>
            {
              record?.dtlResponseList && record?.dtlResponseList.map((item, index) => {
                return (
                  <div key={index}>
                    <div style={{height: 22}}>{item.verifiedAmount}</div>
                    {index < record.dtlResponseList.length - 1 && <Divider style={{ margin: '10px 0' }} />}
                  </div>
                )
              })
            }
          </div>
        )
      },
      sourceCodeRender(text: any, record: any) {
        return (
          <div>
            {
              record?.dtlResponseList && record?.dtlResponseList.map((item, index) => {
                return (
                  <div key={index}>
                    <div style={{height: 22}}>{item.sourceCode}</div>
                    {index < record.dtlResponseList.length - 1 && <Divider style={{ margin: '10px 0' }} />}
                  </div>
                )
              })
            }
          </div>
        )
      },
      sourceTypeRender(text: any, record: any) {
        return (
          <div>
            {
              record?.dtlResponseList && record?.dtlResponseList.map((item, index) => {
                return (
                  <div key={index}>
                    <div style={{height: 22}}>{item.sourceBillTypeName}</div>
                    {index < record.dtlResponseList.length - 1 && <Divider style={{ margin: '10px 0' }} />}
                  </div>
                )
              })
            }
          </div>
        )
      },
      // 新加需求 1005579 - 收款类型
      sourceTypeNameRender(text: any, record: any) {
        return (
          <div>
            {
              record?.dtlResponseList && record?.dtlResponseList.map((item, index) => {
                return (
                  <div key={index}>
                    <div style={{height: 22}}>{item.sourceTypeName}</div>
                    {index < record.dtlResponseList.length - 1 && <Divider style={{ margin: '10px 0' }} />}
                  </div>
                )
              })
            }
          </div>
        )
      },
      // 新加需求 1005579 - 合同类型
      budgetVersionDescRender(text: any, record: any) {
        return (
          <div>
            {
              record?.dtlResponseList && record?.dtlResponseList.map((item, index) => {
                return (
                  <div key={index}>
                    <div style={{height: 22}}>{item.budgetVersionDesc}</div>
                    {index < record.dtlResponseList.length - 1 && <Divider style={{ margin: '10px 0' }} />}
                  </div>
                )
              })
            }
          </div>
        )
      },
      // 新加需求 1005579 - 合同金额
      budgetContractAmountRender(text: any, record: any) {
        return (
          <div>
            {
              record?.dtlResponseList && record?.dtlResponseList.map((item, index) => {
                return (
                  <div key={index}>
                    <div style={{height: 22}}>{item.budgetContractAmount}</div>
                    {index < record.dtlResponseList.length - 1 && <Divider style={{ margin: '10px 0' }} />}
                  </div>
                )
              })
            }
          </div>
        )
      },
    },
  }

  return (
    <Spin spinning={loading}>
      <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
    </Spin>
  )
}